namespace $ {
	/** Release ownership follows existing FQN ancestors, never UI folders or repository URLs. */
	export class $shm_hitalama_components_owner extends $mol_object {
		static definition( definition: $shm_hitalama_map_widget_entity_custom, catalog = definition.Owner_catalog?.()?.remote() ?? null ) {
			if( !catalog ) return definition
			this.$.$shm_hitalama_map_component_ready.read( catalog )
			const name = definition.class_name()
			let owner = definition
			for( let index = name.indexOf( '_' ); index >= 0; index = name.indexOf( '_', index + 1 ) ) {
				const parent = catalog.definition( name.slice( 0, index ) )
				if( !parent ) continue
				this.$.$shm_hitalama_map_component_ready.read( parent )
				owner = parent
				break
			}
			return owner
		}
	}
}
